var slugify = function ( text ) {
    return text.toString().toLowerCase()
        .replace( /\s+/g, '-' ) // Replace spaces with -
        .replace( /[^\w\-]+/g, '' ) // Remove all non-word chars
        .replace( /\-\-+/g, '-' ) // Replace multiple - with single -
        .replace( /^-+/, '' ) // Trim - from start of text
        .replace( /-+$/, '' ); // Trim - from end of text
}

var formatForScreen = function () {
    if ( jQuery( window ).width() < 769 ) {

        jQuery( 'header .navbar, #maincontainer, footer' ).css( {
            'margin-left': '0',
            'margin-right': '0'
        } )

        jQuery( '.product-details' ).attr( 'data-spy', '' ).removeClass( 'text-right affix' ).addClass( 'text-center' ).css( {
            'padding-right':'15px',
            'margin-top': '20px',
            "height": jQuery( window ).height() * 0.4 + 20,
        } );
        jQuery( '.product-photos img' ).css( "max-height", jQuery( window ).height() * 0.4 );
        jQuery( '.product-details, .product-photos' ).css( {

            //"overflow-y" : "scroll"
        } );

        jQuery( 'body' ).css( 'overflow-x', 'hidden' );

        jQuery( '.swatches-wrapper' ).css( 'margin-right', 'auto' );

        if ( jQuery( window ).width() < jQuery( window ).height() ) {
            jQuery( '.product-photos' ).addClass( 'col-sm-offset-3' )
        }
    } else {



        jQuery( '.product-details' ).attr( 'data-spy', 'affix' ).addClass( 'affix text-right' ).removeClass( 'text-center' ).css( {
            "padding-right": "40px",
            "margin-top" : "0px",
            //"height" : "auto"
        } );

        jQuery( '.product-photos' ).removeClass( 'col-sm-offset-3' )

        jQuery( '.product-photos img' ).css( "max-height", jQuery( window ).height() - jQuery( 'footer .navbar' ).height() -
            jQuery( 'nav.navbar' ).height() - 54 );
        // jQuery('.product-photos, .product-photos img').css("max-height" , "");

        // jQuery('.product-photos').removeClass('col-sm-offset-3');
        jQuery( 'body' ).css( 'overflow', 'auto' );
        /*jQuery('.product-details, .product-photos').css({

          "overflow-y" : "auto"
        });*/

    }
    jQuery( '#main' ).css( 'visibility', 'visible' );

}
